import { AttributesMixin, define, Model, type } from "@type-r/models";

export interface ActivityLogCard extends AttributesMixin<typeof ActivityLogCard> { }
@define
export class ActivityLogCard extends Model {

    static idAttribute = "id";

    static attributes = {
        assetId: Number,
        event: String,
        success: Boolean,
        message: String,
        createdOn: Date,
        initiatedBy: type(String).value(''),
    };
}
